<template>
    <div class="filterbar-analytics-practice-streak">
        <button
            v-for="filtertag in filtertags" :key="filtertag.id"
            class="filterbar-analytics-practice-streak__filtertag"
            :class="selectionClass(filtertag)"
            @click="selectFiltertag(filtertag)">
            <span class="filterbar-analytics-practice-streak__filtertag-text">{{ filtertag.text }}</span>
        </button>
    </div>
</template>
<script>
    export default {
        computed: {
            filtertags(){
                return this.$store.state.filtertags.analyticsPractice.practiceStreak;
            },
        },

        methods: {
            selectionClass(filtertag){
                return this.$store.state.selectedFiltertag.analyticsPractice.practiceStreak.type === filtertag.type
                       ? 'filterbar-analytics-practice-streak--selected-filtertag'
                       : '';
            },

            selectFiltertag(filtertag){
                this.$store.commit('setSelectedFiltertagAnalyticsPracticePracticeStreak', filtertag);
                this.$store.state.sfx.filterbarClick.currentTime = 0;
                this.$store.state.sfx.filterbarClick.play();
            }
        }
    };
</script>
<style scoped src="@/css/components/filterbar-analytics-practice-streak.css"></style>